import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Video extends withIntersectionObserver(Base, {
  threshold: 0.1,
}) {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Video',
  };

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.$el.play();
    } else {
      this.$el.pause();
    }
  }
}
